import { extractRefSchema } from 'json-rules-engine-simplified/lib/utils'

export const isDevelopment = () => process.env.NODE_ENV !== 'production'

export const toArray = field => {
  if (Array.isArray(field)) {
    return field
  }
  return [field]
}

export const toError = message => {
  if (isDevelopment()) {
    throw new ReferenceError(message)
  } else {
    // eslint-disable-next-line no-console
    console.error(message)
  }
}

/**
 * Find relevant schema for the field
 * @returns {{ field: "string", schema: "object" }} relevant field and schema
 */
export const findRelSchemaAndField = (field, schema) => {
  const separator = field.indexOf('.')
  if (separator === -1) {
    if (!schema.properties[field]) {
      toError(`Failed to retrieve ${field} from schema`)
    }
    return { field, schema }
  }

  const parentField = field.substr(0, separator)
  const refSchema = extractRefSchema(parentField, schema)
  if (refSchema) {
    try {
      return findRelSchemaAndField(field.substr(separator + 1), refSchema)
    } catch (e) {
      if (e instanceof ReferenceError) {
        toError(`Failed to retrieve ${field} from schema`)
      }
    }
  }

  toError(`Failed to retrieve ${refSchema} from schema`)
  return { field, schema }
}

/**
 * Find relevant uiSchema for the field
 * @returns {{ field: "string", uiSchema: "object" }} relevant field and uiSchema
 */
export function findRelUiSchemaAndField(field, uiSchema) {
  const separator = field.indexOf('.')
  if (separator === -1) {
    if (!uiSchema[field]) {
      toError(`Failed to retrieve ${field} from uiSchema`)
    }
    return { field, uiSchema }
  }

  const parentField = field.substr(0, separator)
  const refUiSchema = uiSchema[parentField]
  if (refUiSchema) {
    try {
      return findRelUiSchemaAndField(field.substr(separator + 1), refUiSchema)
    } catch (e) {
      if (e instanceof ReferenceError) {
        toError(`Failed to retrieve ${field} from uiSchema`)
      }
    }
  }

  toError(`Failed to retrieve ${field} from uiSchema`)
  return { field, uiSchema }
}
